import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const PoweredBy = () => (
  <a
    href="https://workwanderers.com"
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-1.5 text-[10.5px] text-muted hover:text-ink transition-colors"
    data-testid="navbar-powered-by"
  >
    <span>Powered by</span>
    <img src="/wwlogo.png" alt="Work Wanderers" className="h-[18px] w-auto" />
  </a>
);

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const linkCls = 'text-[14.5px] font-medium text-ink-2 hover:text-sea transition-colors';

  return (
    <header
      className="sticky top-0 z-50 border-b"
      style={{
        background: 'rgba(255,255,255,0.93)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottomColor: 'var(--line)',
      }}
    >
      <div className="wrap">
        <nav className="relative flex items-center h-[72px] md:h-[84px] gap-8">
          <Link to="/" className="flex items-baseline gap-2" data-testid="navbar-logo">
            <span className="font-display font-bold text-[18px] tracking-[-0.03em]">Cape&nbsp;Town</span>
            <span className="font-display-italic text-[20px] leading-none">Monthly</span>
          </Link>

          <div className="hidden md:flex items-center gap-6 ml-2">
            <Link to="/listings" className={linkCls} data-testid="navbar-listings-link">Browse listings</Link>
            <Link to="/how-it-works" className={linkCls} data-testid="navbar-how-it-works-link">How it works</Link>
            <Link to="/pricing" className={linkCls} data-testid="navbar-pricing-link">Cost</Link>
            <Link to="/contact" className={linkCls}>Contact</Link>
          </div>

          <div className="ml-auto hidden md:flex flex-col items-end gap-1">
          <div className="flex items-center gap-4">
            {user ? (
              <>
                {user.role === 'host' && (
                  <button onClick={() => navigate('/host/dashboard')} className={linkCls} data-testid="navbar-host-dashboard-btn">
                    Dashboard
                  </button>
                )}
                {user.role === 'guest' && (
                  <button onClick={() => navigate('/guest/dashboard')} className={linkCls} data-testid="navbar-guest-dashboard-btn">
                    Saved
                  </button>
                )}
                {user.role === 'admin' && (
                  <button onClick={() => navigate('/admin/dashboard')} className={linkCls} data-testid="navbar-admin-dashboard-btn">
                    Admin
                  </button>
                )}
                <button onClick={handleLogout} className={linkCls} data-testid="navbar-logout-btn">
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className={linkCls} data-testid="navbar-login-btn">Sign in</Link>
                <Link to="/list-property" className="btn btn-ink" data-testid="navbar-list-property-btn">
                  List your place
                </Link>
              </>
            )}
          </div>
          <PoweredBy />
          </div>

          <button
            className="ml-auto md:hidden flex items-center"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="navbar-mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          <div className="md:hidden absolute right-6 bottom-1"><PoweredBy /></div>
        </nav>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t" style={{ borderTopColor: 'var(--line)' }}>
            <nav className="flex flex-col gap-3">
              <Link to="/listings" className="text-[15px] font-medium">Browse listings</Link>
              <Link to="/how-it-works" className="text-[15px] font-medium">How it works</Link>
              <Link to="/pricing" className="text-[15px] font-medium">Cost</Link>
              <Link to="/contact" className="text-[15px] font-medium">Contact</Link>
              {user ? (
                <>
                  {user.role === 'host' && <Link to="/host/dashboard" className="text-[15px] font-medium">Dashboard</Link>}
                  {user.role === 'guest' && <Link to="/guest/dashboard" className="text-[15px] font-medium">Saved</Link>}
                  {user.role === 'admin' && <Link to="/admin/dashboard" className="text-[15px] font-medium">Admin</Link>}
                  <button onClick={handleLogout} className="text-[15px] font-medium text-left text-red-600">Sign out</button>
                </>
              ) : (
                <>
                  <Link to="/login" className="text-[15px] font-medium">Sign in</Link>
                  <Link to="/list-property" className="btn btn-ink mt-2 self-start">List your place</Link>
                </>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
